import { helper } from '@ember/component/helper';
import bbFrontendGlyphIconToSvg from '@banking/ui/utils/bb-frontend-glyph-icon-to-svg';
function getSvgName([num]) {
  return bbFrontendGlyphIconToSvg(num);
}
export default helper(getSvgName);